import { NurseDashboardWorkspace } from "./DashboardNurse";
import { useAuthExperience } from "../../auth/hooks/useAuthExperience";

const DashboardProviderNurse = () => {
  const authExperience = useAuthExperience();

  return (
    <NurseDashboardWorkspace
      allowProviderWorkspace
      workspaceTitle="Registered Nurse Dashboard"
      workspaceDescription={`As a Registered Nurse - Manage assessments, care plans and delegation forms for other ${authExperience.nurseWorkspace.providerLabel.toLowerCase()} residents you are delegated to.`}
      routeMode="providerNurse"
    />
  );
};

export default DashboardProviderNurse;  
